import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import './PartnerSlider.css';

// Add more duplicated logos to ensure smooth continuous scrolling
const partnerLogos = [
  { src: '/Assets/slider/LEBARA-p-500.png', alt: 'LEBARA' },
  { src: '/Assets/slider/pccwGlobal.png', alt: 'PCCW Global' },
  { src: '/Assets/slider/NextComms.png', alt: 'NextComms' },
  { src: '/Assets/slider/worldMobile.png', alt: 'World Mobile' },
  { src: '/Assets/slider/DIGITAK-p-500.png', alt: 'DIGITAK' },
  { src: '/Assets/slider/IDT.png', alt: 'IDT' },
  { src: '/Assets/slider/WORLDCALL-p-500.png', alt: 'WORLDCALL' },
  { src: '/Assets/slider/SYGMATEL-p-500.png', alt: 'SYGMATEL' },
];

const PartnerSlider = () => {
  return (
    <motion.section 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true, amount: 0.3 }}
      className="partner-slider-section"
    >
      <div className="partner-slider-container">
        <div className="w-full flex justify-center items-center mb-4">
          <motion.h3 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="partner-slider-title inline-block"
          >
            Our Global Partners
          </motion.h3>
        </div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
          className="partner-slider-wrapper"
        >
          {/* Gradient overlays for fade effect - moved inside wrapper for better positioning */}
          <div className="fade-left"></div>
          <div className="fade-right"></div>
          
          <Swiper
            modules={[Autoplay]}
            spaceBetween={40}
            slidesPerView={2}
            loop={true}
            speed={4000} // Slow down the animation speed for smoother effect
            allowTouchMove={false} // Disable touch interaction for continuous flow
            autoplay={{
              delay: 0, // No delay for continuous movement
              disableOnInteraction: false,
              reverseDirection: true, // Move from right to left
              pauseOnMouseEnter: false, // Don't pause on mouse enter
            }}
            breakpoints={{
              640: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 60,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 70,
              },
            }}
            className="py-8"
            dir="rtl" 
          >
            {/* Double the logos for smoother continuous scrolling */}
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <SwiperSlide key={index} className="partner-slide">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="partner-logo"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default PartnerSlider;